module.exports = __webpack_public_path__ + "img/guide2.0c140765.png";